import { FixedSizeGrid as Grid } from 'react-window';
import { useEffect, useState } from 'react';
import { ChallengeDetailsVM } from '../../view-model/ChallengeDetails.viewModel';
import { ListCellRenderer } from '@client/new/pages/promotions/view/components/ListCellRenderer';
import { Typography } from '@design-system/components/typography/typography';
import { FavButton } from './FavButton';
import { Col, Row } from '@design-system/components/grid/grid';
import { Media } from './common/Media';
import { SubmissionCardVM } from '../../view-model/Submission.viewModel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import * as styles from './SubmissionGrid.css';

export const SubmissionsGrid = (p: ChallengeDetailsVM) => {
  const [gridDimensions, setGridDimensions] = useState({
    width: 0,
    columnCount: 0,
    containerHeight: 0,
    rowCount: 0,
  });

  const cardWidth = 340;
  const cardHeight = 310;
  const gap = 24;

  const updateGridDimensions = () => {
    const containerWidth = window.innerWidth - 390;
    const containerHeight = window.innerHeight - 350;

    const maxColumns = Math.floor((containerWidth + gap) / (cardWidth + gap));
    const columnCount = Math.max(1, maxColumns);
    const width = columnCount * cardWidth + columnCount * gap;
    const rowCount = Math.ceil(p.submissions.length / columnCount);

    setGridDimensions({ width, columnCount, containerHeight, rowCount });
  };

  useEffect(() => {
    updateGridDimensions();
    window.addEventListener('resize', updateGridDimensions);
    return () => window.removeEventListener('resize', updateGridDimensions);
  }, [p.submissions]);

  const { width, columnCount, rowCount } = gridDimensions;

  if (width === 0) return null;

  return (
    <Grid
      columnCount={columnCount}
      columnWidth={cardWidth + gap}
      height={gridDimensions.containerHeight}
      rowCount={rowCount}
      rowHeight={cardHeight + gap}
      width={width}
      style={{ width: width + 6 }} // scrollbar
      className={styles.submissionsWrapper}
    >
      {({ columnIndex, rowIndex, style }) => {
        const index = rowIndex * columnCount + columnIndex;
        const item = p.submissions[index];

        return (
          <div
            style={{ ...style, width: cardWidth, height: cardHeight }}
            key={index}
          >
            {item && <SubmissionCard {...item} dispatch={p.dispatch} />}
          </div>
        );
      }}
    </Grid>
  );
};

const SubmissionCard = (
  e: SubmissionCardVM & Pick<ChallengeDetailsVM, 'dispatch'>,
) => (
  <Col className={styles.cardWrapper} onClick={e.onClick} gap="2xl">
    <Row>
      <Col>
        <Media {...e.beforeMedia} />
      </Col>
      <Col>
        <Media {...e.afterMedia} />
      </Col>
    </Row>

    <Row>
      <Col gap="m">
        <Typography fontWeight="bold" variant="bodyLarge">
          {e.showInstagram ? (
            <FontAwesomeIcon
              className={styles.instagramIcon}
              icon={faInstagram}
            />
          ) : null}
          {e.title}
        </Typography>
        <ListCellRenderer data={e.descLine} />
      </Col>
      <FavButton
        isLoading={e.isFavLoading}
        isFav={e.isFav}
        onClick={(ev) => {
          ev.stopPropagation();
          e.dispatch('ToggleFav', e.id);
        }}
      />
    </Row>
  </Col>
);
